const validate = values => {
  const errors = {};
  if (!values.name) {
    errors.establishment = "L'établissement doit être renseigné.";
  }
  if (!values.street) {
    errors.address = "L'adresse doit être renseignée.";
  }
  if (!values.city) {
    errors.city = "La ville n'est pas valide.";
  }
  if (!values.zipcode) {
    errors.zipcode = "Le code postale n'est pas valide.";
  }
  if (!values.country) {
    errors.country = "Le pays n'est pas valide.";
  }
  return errors;
};

export default validate;



// WEBPACK FOOTER //
// ./src/pages/Informations/reduxForm/validate.js